import {Command} from './Command';
import {ChangeMaterialAction} from '../actions';
import {SetMaterialsService} from '../../set-materials.service';

export class ChangeMaterialCommand extends Command<ChangeMaterialAction> {

  private previousMaterial: string;

  constructor(
    private materialSrvc: SetMaterialsService
  ) {
    super();
  }

  do(action: ChangeMaterialAction) {
    this.previousMaterial = this.materialSrvc.getCurrentFloorTexture();
    this.materialSrvc.setMaterial(action.materialName);
  }

  undo() {
    this.materialSrvc.setMaterial(this.previousMaterial);
  }

}




// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/ChangeMaterialCommand.ts